import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@mui/styles';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { mailFolderListItems, otherMailFolderListItems } from '../leftnav';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { InputAdornment, OutlinedInput } from '@mui/material';
import Lock from '@mui/icons-material/Lock';
import Avatar from '@mui/material/Avatar';
import wait from '../reports/loader/wait.svg';
import USER_ROLES from '../common/userroles';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import DashboardIcon from '@mui/icons-material/Dashboard';
import StockPrescriptionIcon from '@mui/icons-material/Unarchive';
import AssignPrescriptionIcon from '@mui/icons-material/NoteAdd';
import ReviewPrescriptionIcon from '@mui/icons-material/CheckCircle';
import SignOutIcon from '@mui/icons-material/PowerSettingsNew';
import BellIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { navigate } from '@reach/router';
import Amplify from 'aws-amplify';
import { Auth } from 'aws-amplify';
import ReportLink from '../leftnav/reportlink';
import ManagemenuLink from '../leftnav/Managemenulink';
import IdleTimer from 'react-idle-timer';
import sound from './images/icr.mp3';
import UserPopUpNotification from '../userPopUpNotification';
/*
  Added By : Belani Jaimin
  Added Date :01/08/2018
  Description: Add Switch for Consult in header part
*/
/*********************** Start *************************** */
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
/*********************** End *************************** */
import packageJson from '../../../package.json';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import Checkbox from '@mui/material/Checkbox';
import TextareaAutosize from 'react-autosize-textarea';
import { toast } from 'react-toastify';
import ilocalboxAvatarlogo from './images/ilocalboxlogo.png';
/**
 * Added By : Mahesh Soni
 * Added Date :02/20/2021
 * Description: importing crypter for enccrupting password for creating secure badge
 * */
import defaultLoader from './images/loader.gif';
import Crypter from 'cryptr';
import {
  deleteFirebaseToken,
  getFirebaseToken,
  onMessageListenerFCM,
} from '../../config/firebase';
import io from 'socket.io-client';
import { Box, ListItemIcon } from '@mui/material';
import { AttachEmail } from '@mui/icons-material';
import { Link } from '@reach/router';
import { ConnectIdleTimerComponent } from '../common/ConnectIdleTimerComponent';
import { ActivityIdleTimerComponent } from '../common/ActivityIdleTimerComponent';
import { NotificationWrapperComponent } from '../common/NotificationWrapperComponent';
import { withTranslation } from 'react-i18next';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import connectionType from '../common/connection-type';
import Zoom from '../TwilioProgrammableVideo/ZoomVideo';
const { log } = console;

const sw = navigator.serviceWorker;
const secretKey = process.env.REACT_APP_CIPHER;
const crypter = new Crypter(secretKey);
Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_CG_REGION,
    userPoolId: process.env.REACT_APP_CG_USERPOOLID,
    userPoolWebClientId: process.env.REACT_APP_CG_WEBCLIENTID,
  },
});

const drawerWidth = localStorage.getItem('i18nextLng') === 'en' ? 276 : 420;
//create date prototype for date format for duration calculation
const padLeft = (chr) => {
  const base = 10;
  const len = String(base || 10).length - String(chr).length + 1;
  return len > 0 ? new Array(len).join('0') + chr : chr;
};
window.state = false;
const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
  },
  appBar: {
    position: 'fixed',
    height: '68px',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: '#00a7e1 !important',
    color: '#fff !important',
  },
  appBarShift: {
    position: 'fixed',
    // marginLeft: drawerWidth,
    // width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: '14px !important',
    marginRight: '12px !important',
    color: 'white',
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    maxWidth: '72px',
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: '72px',
    [theme.breakpoints.up('sm')]: {
      width: '72px',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  contentWithMiniLeftNav: {
    [theme.breakpoints.up('sm')]: {
      marginLeft: 72,
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: 56,
    },
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    flexGrow: 1,
    // backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
  content: {
    // [theme.breakpoints.up('sm')]: {
    marginLeft: localStorage.getItem('i18nextLng') === 'en' ? 276 : 420,
    // },
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    flexGrow: 1,
    // backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
  flex: {
    //paddingLeft: '1rem',
    flex: 1,
    fontSize: '1.3125rem',
    fontWeight: '500',
  },
  rightIcon: {
    paddingRight: 12,
    padding: 11,
  },
  avatar: {
    // margin: 10,
  },
  userName: {
    float: 'right',
    lineHeight: '49px',
    paddingLeft: '6px',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
    cursor: 'pointer',
    marginTop: '11px',
  },
  signOutButton: {
    '&.MuiButtonBase-root': {
      float: 'right',
      marginRight: '10px !important',
      color: '#fafafa',
    },
  },
  bellButton: {
    color: '#fafafa',
    //paddingLeft: '10px',
    marginRight: '10px',
  },
  bellBadge: {
    color: '#d32f2f',
  },
  badgeColor: {
    color: 'white',
  },
  bottomNav: {
    width: '100vw',
    position: 'fixed',
    bottom: 0,
    left: 0,
    zIndex: 10000,
    backgroundColor: '#EFEFEF',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  errorText: {
    paddingTop: '10px',
    color: 'red',
  },
  /* Added By :Belani Jaimin */
  /******************* START ******************/
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: '#ef8d22',
      '& + $iOSBar': {
        backgroundColor: '#fff !important',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(20px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: '10px',
    width: 70,
    height: 31,
    marginTop: -15,
    marginLeft: -32,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 50,
    height: 28,
    //background:'#efefef',
    border: '1px solid #e3e3e3',
    borderRadius: '10px !important',
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
  DialogText: {
    color: 'black',
  },
  DialogContentWrap: {
    width: '500px',
  },
  ButtonAlign: {
    justifyContent: 'space-around',
    paddingBottom: '20px',
  },
  loader: {
    justifyContent: 'center',
    textAlign: 'center',
    position: 'absolute',
    width: '100%',
    left: 0,
    top: '0%',
    height: '100%',
    zIndex: '999999',
    display: 'flex',
    background: 'rgba(255,255,255,0.3)',
  },
  loaderImage: {
    width: '80px',
    zIndex: ' 999999999',
    position: 'absolute',
    top: '25%',
  },
  buttonFace: {
    color: '#387371',
  },
  footer: {
    //background: '#0a5d66',
    background: '#00a7e1 !important',
    color: '#fff !important',
    padding: '0px 24px',
    //boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
    position: 'fixed',
    width: '100%',
    zIndex: '9999',
    bottom: 0,
    fontSize: '14px',
    fontWeight: '400',
  },
  consultDialogBox: {
    width: '100%',
    border: '4px solid dodgerblue',
    borderRadius: '60px',
  },
  consultDialogTitle: {
    textAlign: 'center',
  },
  consultLocationName: {
    color: 'dodgerblue',
  },
  consultDialogText: {
    paddingTop: '5%',
    color: 'black',
  },
  consultDialogDataContainer: {
    textAlign: 'center',
    margin: '5% 23% 0',
  },
  consultDialogPatientImage: {
    width: '120px',
    height: '120px',
    marginBottom: '7%',
    borderRadius: '60px',
  },
  consultDialogButtons: {
    marginTop: 0,
    paddingBottom: '5%',
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff !important',
    '&:hover': {
      background: '#6cca98',
      color: '#fff !important',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8',
    },
  },
  diagnostics_dialogbox: {
    '& .MuiPaper-root': {
      maxWidth: '100% !important',
      width: '100% !important',
      height: '100% !important',
      '& .container': {
        width: 'inherit',
        height: 'inherit',
        '& iframe': {
          width: 'inherit',
          height: 'inherit',
        },
      },
    },
    '& .MuiDialogTitle-root': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  /******************* END ******************/
});

let kioskNotificationInterval = null;
class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: window.innerWidth > 768,
      openNotification: window.innerWidth > 768, //Added by Naresh | DI-461 | Date:16-04-2019
      anchorEl: null,
      anchorElNotification: null,
      value: 0,
      checkedB: false,
      consultOpen: false,
      PatientName: '',
      Notifications: {},
      //Vidyo part
      microphones: {},
      speakers: {},
      cameras: {},
      /* screen sharing */
      screenShares: {},
      isSharing: false,
      /* toolbar props */
      buttonsAvailable: false,
      participantStatus: '',
      connectionStatus: '',
      clientVersion: '',
      screenShareButtonState: true,
      microphoneButtonState: true,
      joinLeaveButtonState: true,
      cameraButtonState: true,
      /* EntranceForm props */
      hosts: 'prod.vidyo.io',
      resourceId: 'iLocalBoxRoom',
      displayName: 'iLocalBox',
      vidyoConnectors: null,
      startConsult: false,
      SetConsultOn: 0,
      LoggedInUserName: '',
      userConsultMaster: {},
      isUnplugged: false,
      isPaymentRequired: false,
      rolepermission: [],
      openWarning: false,
      time: 5,
      isButtonDisabled: false,
      loader: false,
      Pickupcode: '',
      PatietPrescriptionData: '',
      PatientEmail: '',
      PatientPhone: '',
      PatientDOB: '',
      consultnotes: '',
      ReleaseOrder: false,
      ReleaseOrderOpen: false,
      isOpen: false,
      isdisable: false,
      notificationDetails: '',
      consultpermission: false,
      userRole: null,
      ilocalboxAvatarprofile: ilocalboxAvatarlogo,
      isFirebaseNotification: false,
      firebaseNotification: { title: '', body: '' },
      consultRequestFCM: {},
      orderNotReleasedOpen: false,
      refreshDialog: false,
      openConsultDiagnostics: false,
      checkedBDialog: false,
      isNormalConsult: false,
      consultAcknowledgeDialog: false,
      refreshServiceWorker: false,
      notificationData: {},
      notificationCount: 0,
      sessionID: null,
      showWarning: false,
      showTroubleTitle: false
    };
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeCreateSecureBadgePassword = this.handleChangeCreateSecureBadgePassword.bind(
      this
    );
    this.handleSubmitCreateSecureBadge = this.handleSubmitCreateSecureBadge.bind(
      this
    );

    this.idleTimer = null;
    this.onAction = this._onAction.bind(this);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
    this.startTimer = this.startTimer.bind(this);
    this.stopTimer = this.stopTimer.bind(this);
    this.resetTimer = this.resetTimer.bind(this);
    this.zoom = null;
    this.oktaAuthClient = window.oktaAuthClient;
    this.maxTokenRefreshAllowance = 1;
    console.log('Open....', this.state.open);
    window.refreshInterval = null;
    this.handleResetRefreshDialog = this.handleResetRefreshDialog.bind(this);
    this.handleConsultAcknowledgeDialog = this.handleConsultAcknowledgeDialog.bind(
      this
    );
    let User = JSON.parse(sessionStorage.getItem('user'));
    !this.notificationSocket && this.initNotificationSocket({ User });
  }

  initSocket = async () => {
    if (!this.socket && this.user) {
      /**
       ** Socket Initialization **
       */

      this.socket = io(process.env.REACT_APP_VIDEO_SOCKET_BASEURL, {
        transports: ['websocket'],
        auth: {
          token: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`,
          isPortal: true,
          userId: this.user.id || this.user.username,
        },
        secure: true,
        reconnectionAttempts: 5,
        closeOnBeforeunload: true,
      });

      window.socket = this.socket;

      /**
       ** Internal Socket Event **
       */

      this.socket &&
        this.socket.on('connect', () => {
          console.log('Socket connection established from PORTAL(ReConnect)');
        });
      this.socket &&
        this.socket.on('connect_error', async (error) => {
          console.log('Connect Error: ', error);
          if (
            this.maxTokenRefreshAllowance &&
            (error.message === 'TokenExpiredError' ||
              error.message === 'JsonWebTokenError' ||
              error.message === 'NoTokenFound')
          ) {
            if (this.maxTokenRefreshAllowance < 5) {
              await this.refreshToken();
              this.socket && (await this.socket.disconnect());
              this.socket = false;
              console.log('Initializing Socket with latest token.');
              this.maxTokenRefreshAllowance += 1;
              await this.initSocket();
            } else {
              alert('Something went wrong! Please login again.');
              this.signOut();
            }
          }
        });
      this.socket &&
        this.socket.on('connect_failed', (error) => {
          console.log('Connect Failed: ', error);
        });
      this.socket &&
        this.socket.on('error', (error) => {
          console.log('Error: ', error);
        });
      this.socket &&
        this.socket.on('disconnect', (reason) => {
          console.log(
            `Socket Disconnected From Portal and Reason is: ${reason}`
          );
        });

      /**
       ** Socket Consult Event Starts **
       */

      this.socket &&
        this.socket.on('callAccepted', (payload) => {
          console.log(payload);
          this.handleConsultClose();
        });
      this.socket &&
        this.socket.on('endSession', (payload) => {
          console.log(payload);
          this.zoom.leaveRoom();
          this.zoom ? this.zoom.leaveRoom() : this.handleConsultClose();
        });
      this.socket &&
        this.socket.on('callAlreadyAccepted', (payload) => {
          console.log(payload);
          payload &&
            payload.pucode &&
            payload.pucode
              .toUpperCase()
              .includes(this.state.Pickupcode.toUpperCase()) &&
            this.handleConsultClose();
        });
      this.socket &&
        this.socket.on('endSessionCancelConsult', (payload) => {
          console.log(payload);
          payload &&
            payload.pucode &&
            payload.pucode
              .toUpperCase()
              .includes(this.state.Pickupcode.toUpperCase()) &&
            this.handleConsultClose();
        });
      this.socket &&
        this.socket.on('endSessionDisconnectedConsult', (payload) => {
          console.log(payload);
          payload &&
            payload.pucode &&
            payload.pucode
              .toUpperCase()
              .includes(this.state.Pickupcode.toUpperCase()) &&
            (this.zoom ? this.zoom.leaveRoom() : this.handleConsultClose());
        });

      /**
       * Socket Manual Override Events
       */
      this.socket &&
        this.socket.on('openBinSuccess', (payload) => {
          console.log(payload);
          toast.success(
            `${this.props.t('Toast.OpenBin')} ${payload.bin} ${this.props.t(
              'Toast.Success'
            )}`
          );
        });
      this.socket &&
        this.socket.on('BoxIdConfigured', (payload) => {
          console.log(payload);
        });
    }
  };

  initNotificationSocket = async ({ User }) => {
    if (!this.notificationSocket && User) {
      this.notificationSocket = io(
        process.env.REACT_APP_VIDEO_SOCKET_BASEURL + '/notification',
        {
          transports: ['websocket'],
          auth: {
            token: `Bearer ${User.signInUserSession.idToken.jwtToken}`,
          },
          secure: true,
        }
      );

      window.notificationSocket = this.notificationSocket;
      this.notificationSocket &&
        this.notificationSocket.on('connect', () => {
          console.log('Socket connection established from PORTAL(ReConnect)');
        });

      this.notificationSocket &&
        this.notificationSocket.on('error', (error) => {
          console.log('Error: ', error);
        });
      this.notificationSocket &&
        this.notificationSocket.on('disconnect', (reason) => {
          console.log(
            `Socket Disconnected From Portal and Reason is: ${reason}`
          );
        });

      this.notificationSocket &&
        this.notificationSocket.emit('UserSubscribeNotificationEvent', {
          UserID: User.username,
          Message: `User: ${User.username} subscribe notification from connect!`,
        });

      this.notificationSocket &&
        this.notificationSocket.on(
          'UserReceiveNotificationEvent',
          (payload) => {
            console.log('(UserReceiveNotificationEvent):', payload);
            this.gettingTaskNotification(true);
          }
        );
    }
  };

  initFirebaseFCM = async () => {
    if (!this.firebaseToken) {
      this.firebaseToken = await getFirebaseToken(
        !this.state.refreshServiceWorker &&
        (() =>
          this.setState({
            refreshServiceWorker: true,
          }))
      );
      // getting FCM Token to store in user table
      if (this.firebaseToken) {
        await fetch(
          process.env.REACT_APP_BASEURL + `fcm/user/set/${this.firebaseToken}`,
          {
            method: 'PUT',
            headers: {
              Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken
                }`,
              'Content-Type': 'application/json',
            },
          }
        );
      }
    }
  };

  // Timer is being Added by Jaydutt Shukla on 24/04/19
  _onAction(e) { }

  _onActive(e) { }

  _onIdle(e) {
    this.handleClickOpen();
    this.startTimer();
  }
  startTimer() {
    this.setState({
      time: this.state.time,
    });
    this.timer = setInterval(() => {
      this.setState({
        time: this.state.time - 1,
      });
      if (this.state.time === 0) {
        this.stopTimer();
        this.handleBack();
      }
    }, 1000);
  }
  stopTimer() {
    this.resetTimer();
    clearInterval(this.timer);
    this.idleTimer = null;
  }
  resetTimer() {
    this.setState({ time: 5 });
  }
  handleClickOpen = () => {
    this.setState({ openWarning: true });
    window.state = this.state.openWarning;
    setTimeout(() => {
      if (window.state) {
      }
    }, 10000);
  };
  handleCloseTimerPopUp = () => {
    this.setState({ openWarning: false });
    this.stopTimer();
    window.state = false;
  };
  handleBack = () => {
    clearInterval(kioskNotificationInterval);
    this.signOut();
  };

  playCallSound = async (pause = false) => {
    let audioElement = document.getElementById('callSound');
    audioElement.src = sound;
    pause && (audioElement.muted = true);
    await audioElement.play();
    setTimeout(() => {
      pause && audioElement.pause();
      audioElement.muted = false;
    }, 1000);
  };

  async componentDidUpdate() {
    if (this.state.checkedB) {
      !this.socket &&
        (await this.initSocket().then(() =>
          console.log('ComponentUpdated calling: InitSocket!')
        ));
      log({
        page: 'Home',
        function: 'componentDidUpdate',
        name: 'initializeFirebaseToken',
        data: this.firebaseToken,
        message: 'Checking if firebaseToken is available or not!',
        date: new Date()
      })
      !this.firebaseToken &&
        (await this.initFirebaseFCM().then(() =>
          console.log('ComponentUpdated calling: InitSocket!')
        ));
      onMessageListenerFCM()
        .then((payload) => {
          if (payload) {
            this.setState(
              {
                isFirebaseNotification: true,
                firebaseNotification: {
                  title: payload.notification.title,
                  body: payload.notification.body,
                },
                Pickupcode: payload.notification.body,
              },
              () => {
                console.log('***FCM Notification Received: Foreground***');
              }
            );
            console.log(
              '***ConsultCallback Function Call From : FCM Forground***'
            );
            !!!this.state.consultOpen &&
              !!!this.state.startConsult &&
              this.consultCallback();
            console.log('Pickupcode: ' + this.state.Pickupcode);
          }
        })
        .catch((err) => console.log('failed: ', err));
    }
  }

  componentDidMount() {
    let preferredLang = sessionStorage.getItem('preferredLanguage');
    if (preferredLang !== '' && preferredLang !== undefined) {
      this.props.i18n.changeLanguage(preferredLang);
    }
    setTimeout(() => {
      this.playCallSound(true);
    }, 2000);
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.refreshToken();
    let consultBlackList = JSON.parse(localStorage.getItem('consultBlackList'));
    if (consultBlackList && consultBlackList.length > 0) {
      // do nothing!
    } else {
      let blackConsultBlackList = [];
      localStorage.setItem(
        'consultBlackList',
        JSON.stringify(blackConsultBlackList)
      );
    }
    fetch(process.env.REACT_APP_BASEURL + 'releasing/history', {
      method: 'GET',
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((res) => {
        if (res) {
          this.setState({ notificationDetails: res.releasingHistory });
        }
      });
    let role = JSON.parse(sessionStorage.getItem('superadmin'));
    if (role !== USER_ROLES.SUPERADMIN) {
      this.setState({ isOpen: true });
    }
    fetch(
      process.env.REACT_APP_BASEURL +
      'users/' +
      JSON.parse(sessionStorage.getItem('user')).username,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((userData) => {
        if (userData) {
          const accountConnectionId = userData && userData[0] && userData[0].parentAccount && userData[0].parentAccount.account_connections_id;
          localStorage.setItem('isNumericCode', userData[0].parentAccount.is_numeric_code)
          sessionStorage.setItem('accountConnectionId', accountConnectionId)
          sessionStorage.setItem('is_pre_assignment', userData && userData[0] && userData[0].parentAccount && userData[0].parentAccount.is_pre_assignment)
          const isUnplugged = accountConnectionId === connectionType.UNPLUGGED ? true : false;
          this.setState({
            LoggedInUserName:
              (userData && userData[0] && userData[0].name) || userData.name,
            userData,
            isUnplugged,
          });
          let permissions = JSON.parse(sessionStorage.getItem('permissions'));
          if (permissions && permissions.length > 0) {
            let consultpermission = false;
            for (let i = 0; i < permissions.length; i++) {
              if (
                permissions[i].name === 'Consult' &&
                permissions[i].is_allowed === 1
              ) {
                consultpermission = true;
              }
            }
            this.setState({ consultpermission });
          }
        }
      });
    //Added By : Belani Jaimin
    fetch(
      process.env.REACT_APP_BASEURL +
      'userconsultflag/' +
      JSON.parse(sessionStorage.getItem('user')).username,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(async (uData) => {
        if (uData !== null && uData !== '') {
          const userConsultData = JSON.parse(uData);
          if (userConsultData && userConsultData.length > 0) {
            if (
              (userConsultData &&
                userConsultData[0] &&
                userConsultData[0].is_user_consult) ||
              userConsultData.is_user_consult
            ) {
              !this.socket &&
                (await this.initSocket().then(() =>
                  console.log('UserConsultFlag calling: InitSocket!')
                ));
              !this.firebaseToken &&
                (await this.initFirebaseFCM().then(() =>
                  console.log('UserConsultFlag calling: InitFirebaseFCM!')
                ));
            }
            userConsultData[0].is_user_consult ||
              userConsultData.is_user_consult === true
              ? this.setState({
                checkedB: true,
                checkedBDialog: Boolean(
                  !this.state.refreshServiceWorker &&
                  !localStorage.getItem('consultDiagnosticsShowed')
                ),
              })
              : this.setState({
                checkedB: false,
                checkedBDialog: false,
                consultAcknowledgeDialog: Boolean(
                  !localStorage.getItem('consultAcknowledgeShowed')
                ),
              });
          } else {
            this.setState({
              checkedB: false,
              checkedBDialog: false,
              consultAcknowledgeDialog: Boolean(
                !localStorage.getItem('consultAcknowledgeShowed')
              ),
            });
          }
        }
      });
    this.handleResetRefreshDialog();
    this.gettingTaskNotification(false);
  }

  checkFCMServiceWorker() {
    if (this.state.checkedB && sw && sw.getRegistrations) {
      sw.getRegistrations().then(async (registrations) => {
        if (
          registrations &&
          registrations.findIndex((data) =>
            data.active.scriptURL.includes('firebase-messaging-sw.js')
          ) === -1
        ) {
          window.location.reload();
        } else {
          !this.firebaseToken &&
            (await this.initFirebaseFCM().then(() =>
              console.log('ServiceWorker reinstalled calling: InitFirebaseFCM!')
            ));
        }
      });
    }
  }

  handleResetRefreshDialog() {
    window.refreshInterval &&
      clearInterval(window.refreshInterval) &&
      (window.refreshInterval = null);
    this.setState({ refreshDialog: false });
    this.checkFCMServiceWorker();
    window.refreshInterval = setInterval(() => {
      this.checkFCMServiceWorker();
      !this.state.refreshDialog &&
        this.setState({ refreshDialog: true, checkedBDialog: false });
    }, 1000 * 60 * 60);
  }

  handleConsultAcknowledgeDialog() {
    this.setState({ consultAcknowledgeDialog: false });
    this.handleSwitchChange(true);
  }

  refreshToken = async () => {
    try {
      console.log('Refresh Token Init.');
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = cognitoUser && cognitoUser.signInUserSession;
      const idTokenExpire =
        this.user.signInUserSession.idToken.payload.exp * 1000;
      const currentTimeSeconds = +new Date();
      if (idTokenExpire < currentTimeSeconds) {
        console.log('Token is expired! Initiating Token Refresh.');
        cognitoUser.refreshSession(
          currentSession.refreshToken,
          (err, session) => {
            console.log('Token Refreshed from expiry!');
            this.user = cognitoUser;
            sessionStorage.setItem('user', JSON.stringify(cognitoUser));
          }
        );
      }
      !this.refreshTokenInterval &&
        (this.refreshTokenInterval = setInterval(async () => {
          console.log('Refresh Token Interval Called!');
          cognitoUser.refreshSession(
            currentSession.refreshToken,
            (err, session) => {
              console.log('Token Refreshed from interval.');
              this.user = cognitoUser;
              sessionStorage.setItem('user', JSON.stringify(cognitoUser));
            }
          );
        }, 55 * 60 * 1000));
      return currentSession;
    } catch (e) {
      console.error('Refresh Token Error: ', e);
    }
  };

  //Added By Naresh | DI-461 | Date:16-04-2019 |Kiosk Offline Notification
  getKioskNotification = () => {
    let user = JSON.parse(sessionStorage.getItem('user'));
    let token =
      user &&
      user.signInUserSession &&
      user.signInUserSession.idToken &&
      user.signInUserSession.idToken.jwtToken;
    if (token && token !== undefined) {
      fetch(process.env.REACT_APP_BASEURL + 'getKioskNotification', {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((boxesOffline) => {
          let mergeArray = [];
          if (boxesOffline.boxesOffline.length > 0) {
            mergeArray = mergeArray.concat(boxesOffline.boxesOffline);
          }
          if (boxesOffline.schedule.length > 0) {
            mergeArray = mergeArray.concat(boxesOffline.schedule);
          }
          this.setState({ boxesOfflineNotification: mergeArray });
        });
    }
  };

  consultCallback = () => {
    console.log('***ConsultCallback Function : Called***');
    let user = JSON.parse(sessionStorage.getItem('user'));
    if (
      user !== undefined ||
      user !== 'undefined' ||
      user !== null ||
      user !== 'null' ||
      user !== ''
    ) {
      fetch(
        `${process.env.REACT_APP_BASEURL}getNotificationsByUserId/${user.username}`,
        {
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: 'Bearer ' + user.signInUserSession.idToken.jwtToken,
            'Content-Type': 'application/json',
          },
        }
      )
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then((uData) => {
          if (uData[0]) {
            console.log(
              'Before opening accept/decline popup: ' + JSON.stringify(uData[0])
            );
            this.handleConsultClickOpen();
            this.setNotificationObject(uData[0]);
            this.setPatientName(uData[0]);
          } else {
            console.log(
              'No record in getNotificationsByUserId response!!!!!!!'
            );
            this.handleConsultClose();
          }
        });
    }
  };

  state = {
    open: window.innerWidth > 768,
    openNotification: window.innerWidth > 768, //Added by Naresh | DI-461 | Date:16-04-2019
    anchorEl: null,
    anchorElNotification: null,
    value: 0,
  };

  handleConsultClickOpen = () => {
    this.setState({ consultOpen: true });
    this.playCallSound();
  };

  acceptConsultCall = () => {
    let audioElement = document.getElementById('callSound');
    audioElement.src = sound;
    audioElement.pause();
    this.setState({ isButtonDisabled: true, loader: true });
    var notificationObj = {
      user_consult_notification_id: this.state.Notifications
        .user_consult_notification_id,
      User_name: this.state.Notifications.User_name,
      is_consult_accepted: true,
      is_consult_end_call: false,
      is_user_end_call: false,
      resource_id: this.state.Notifications.resource_id,
      notification_id: this.state.Notifications.notification_id,
      user_id: JSON.parse(sessionStorage.getItem('user')).username,
      consult_start_date: new Date(),
      consult_end_date: null,
      is_call_status: 'Accepted',
      auth_token: this.state.Notifications.auth_token,
      consultant_name: this.state.LoggedInUserName,
      is_releaseorder: this.state.Notifications.is_releaseorder,
      pharmacist_id: this.state.Notifications.user_id,
    };
    fetch(process.env.REACT_APP_BASEURL + 'notificationUpdate', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(notificationObj),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        console.log('Call accepted!!!! ');
        this.socket &&
          this.socket.emit('videoCallAccepted', {
            pucode: this.state.Pickupcode.toString(),
            message: 'Call Accepted from Portal.',
          });
        this.startConsultation();
        this.handleConsultClose();
        clearInterval(window.otherUsersInterval);
        !!!this.state.Notifications.notification_id &&
          this.getPrescriptionDetailByPickupCode(this.state.Pickupcode);
      })
      .catch((err) => {
        console.log('acceptConsultCall method error: ' + err);
      });

    fetch(process.env.REACT_APP_BASEURL + 'createSession', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify({ pucode: this.state.Pickupcode }),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        if (data && data.authToken) {
          console.log("Session created for auth token***")
          this.setState({ sessionID: data.sessionId })
        } else {
          console.log("Session does not created for auth token***")
        }
      })
      .catch(err => {
        console.log(`Session for auth token error : ${err}`)
      })
  };

  declineConsultCall = () => {
    this.socket &&
      this.socket.emit('videoCallDeclined', {
        pucode: this.state.Pickupcode,
        message: 'Pharmacist declined video call.',
      });
    let audioElement = document.getElementById('callSound');
    audioElement.src = sound;
    audioElement.pause();
    var endSessionObj = {
      user_consult_notification_id: this.state.Notifications
        .user_consult_notification_id,
      is_consult_end_call: false,
      is_user_end_call: false,
      is_call_status: 'Rejected',
    };
    fetch(process.env.REACT_APP_BASEURL + 'endconsultsession', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(endSessionObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        let consultBlackList = JSON.parse(
          localStorage.getItem('consultBlackList')
        );
        let consultalreadyBlocked;
        if (consultBlackList.length > 0) {
          consultBlackList.every((blockedConsult) => {
            if (
              blockedConsult.consultId === uData.user_consult_notification_id
            ) {
              consultalreadyBlocked = true;
              return false; // This will break the loop if id matched!
            } else {
              consultalreadyBlocked = false;
            }
            return false;
          });
          if (!consultalreadyBlocked) {
            consultBlackList.push({
              consultId: uData.user_consult_notification_id,
              created_on: uData.created_on,
            });
            localStorage.setItem(
              'consultBlackList',
              JSON.stringify(consultBlackList)
            );
          }
        } else {
          consultBlackList.push({
            consultId: uData.user_consult_notification_id,
            created_on: uData.created_on,
          });
          localStorage.setItem(
            'consultBlackList',
            JSON.stringify(consultBlackList)
          );
        }
        this.handleConsultClose();
        clearInterval(window.otherUsersInterval);
      });
  };

  endConsultationSession = () => {
    this.zoom ? this.zoom.leaveRoom() : this.handleConsultClose();
    this.socket &&
      this.socket.emit('completeConsult', {
        pucode: this.state.Pickupcode,
        message: 'Comple consult from portal',
      });
    this.setState({ startConsult: false, orderNotReleasedOpen: false });
    var endSessionObj = {
      user_consult_notification_id: this.state.Notifications
        .user_consult_notification_id,
      is_consult_end_call: true,
      is_user_end_call: false,
      is_call_status: 'Completed',
    };
    fetch(process.env.REACT_APP_BASEURL + 'endconsultsession', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(endSessionObj),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.getNotificationByNotificationID(
          this.state.Notifications.user_consult_notification_id
        );
      });
  };

  saveConsultMasterEntry = (uData) => {
    var uDatas = JSON.parse(uData);
    var masterObj = {
      consult_start_date: uDatas.consult_start_date,
      consult_end_date: uDatas.consult_end_date,
      pickup_code: uDatas.resource_id,
      notification_id: uDatas.notification_id,
      user_name: uDatas.User_name,
      call_duration: this.getMinutes(
        uDatas.consult_start_date,
        uDatas.consult_end_date
      ),
      user_id: uDatas.user_id,
      consultation_name: uDatas.consultant_name,
      Status: uDatas.is_call_status,
      accounts_id: uDatas.accounts_id,
      store_name: uDatas.store_name,
      box_id: uDatas.box_id,
      kiosk_name: uDatas.kiosk_name,
      consultation_notes: this.state.consultnotes,
      is_releaseorder: this.state.ReleaseOrder,
    };
    fetch(process.env.REACT_APP_BASEURL + 'saveuserconsult', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(masterObj),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => { });
  };

  minsToHHMMSS = (resultInMinutes) => {
    var mins_num = parseFloat(resultInMinutes, 10);
    var hours = Math.floor(mins_num / 60);
    var minutes = Math.floor(mins_num - (hours * 3600) / 60);
    var seconds = Math.floor(mins_num * 60 - hours * 3600 - minutes * 60);
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    return hours + ':' + minutes + ':' + seconds;
  };

  getMinutes = (consult_start_date, consult_end_date) => {
    if (
      (consult_start_date !== '' || consult_start_date !== undefined) &&
      (consult_end_date !== '' || consult_end_date !== undefined)
    ) {
      var startTime = this.getFormattedDate(consult_start_date);
      var endTime = this.getFormattedDate(consult_end_date);
      var difference =
        new Date(endTime).getTime() - new Date(startTime).getTime();
      var resultInMinutes = difference / 60000;
      return this.minsToHHMMSS(resultInMinutes);
    } else {
      return '';
    }
  };

  getFormattedDate = (date) => {
    var d = new Date(date),
      dformat =
        [d.getFullYear(), padLeft(d.getMonth() + 1), padLeft(d.getDate())].join(
          '/'
        ) +
        ' ' +
        [
          padLeft(d.getHours()),
          padLeft(d.getMinutes()),
          padLeft(d.getSeconds()),
        ].join(':');
    return dformat;
  };

  getNotificationByNotificationID = (notificationId) => {
    fetch(
      process.env.REACT_APP_BASEURL + 'getNotificationByid/' + notificationId,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        if (uData !== null && uData !== '') {
          this.saveConsultMasterEntry(uData);
        }
      });
  };

  setPatientName = (uData) => {
    this.setState({
      PatientName: uData.User_name,
      Pickupcode: uData.resource_id || uData.notification_id,
      isNormalConsult: Boolean(uData.notification_id),
    });
  };

  setNotificationObject = (udatas) => {
    this.setState({
      Notifications: udatas,
      ReleaseOrder: udatas.is_releaseorder,
      consultnotes: udatas.consultation_notes,
    });
  };

  startConsultation = () => {
    this.setState({
      startConsult: true,
      loader: false,
      isButtonDisabled: false,
    });
  };

  handleConsultClose = () => {
    let audioElement = document.getElementById('callSound');
    audioElement.src = sound;
    audioElement.pause();
    this.setState({
      consultOpen: false,
      loader: false,
      isButtonDisabled: false,
      orderNotReleasedOpen: false,
    });

    //this.declineConsultCall();
  };

  handleBottomNavChange = (event, value) => {
    this.setState({ value });
  };

  handleChange = (event, checked) => {
    this.setState({ auth: checked });
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose_menu = () => {
    this.setState({ anchorEl: null });
  };

  //Added By Naresh | DI-461 | Date:16-04-2019 |Kiosk Offline Notification
  handleOpenNotificationMenu = (event) => {
    this.setState({ anchorElNotification: event.currentTarget });
    const { notificationData, replica } = this.state;
    if (
      typeof notificationData === 'object' &&
      Object.keys(notificationData)['length'] === 0
    ) {
      return true;
    }

    setTimeout(() => {
      if (replica) {
        this.updateTaskNotification(replica);
        this.setState((prevState) => ({
          notificationCount: prevState['notificationCount'] - replica['length'],
          replica: null,
        }));
      }
    }, 200);
  };

  handleCloseNotificationMenu = () => {
    this.setState({ anchorElNotification: null });
  };
  //End Naresh | Kiosk Offline Notification

  handleClose = (event) => {
    this.setState({
      showChangePasswordDialog: false,
      errorMessage: '',
      createSecureBadgeDialog: false,
      isOpen: false,
    });
  };

  removeFirebaseFCM = async () => {
    let user = sessionStorage.getItem('user');
    let token =
      user && JSON.parse(user || '{}').signInUserSession.idToken.jwtToken;
    await deleteFirebaseToken();
    return fetch(`${process.env.REACT_APP_BASEURL}fcm/removeToken`, {
      method: 'PUT',
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({}),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        this.firebaseToken = false;
        return res.success;
      });
  };

  signOut = () => {
    this.state.checkedB &&
      this.removeFirebaseFCM() &&
      this.socket &&
      this.socket.disconnect();

    if (this.oktaAuthClient) {
      this.oktaAuthClient.signOut({
        postLogoutRedirectUri: `${window.location.origin}/`,
      });
    } else {
      navigate(`/`);
    }

    console.log('Signing Out ✌🏻');
    clearInterval(this.timer);
    clearInterval(window.otherUsersInterval);
    clearInterval(kioskNotificationInterval);
    clearInterval(this.refreshTokenInterval);
    this.setState({ anchorEl: null, checkedB: false, checkedBDialog: false });
    sessionStorage.setItem('user', JSON.stringify({}));
    sessionStorage.setItem('permissions', JSON.stringify([]));
    sessionStorage.removeItem('roleId');
    this.socket = false;
  };

  handleChangePasswored = () => {
    this.setState({ anchorEl: null, showChangePasswordDialog: true });

    // navigate(`/`);
  };

  handleSubmit = (event) => {
    if (
      !this.state.new_password ||
      !this.state.confirm_new_password ||
      this.state.new_password === this.state.confirm_new_password
    ) {
      this.setState({ confirm_new_password_error: null });
      let user_id = JSON.parse(sessionStorage.getItem('user')).username;
      let sha256 = require('js-sha256');
      let pw_hash = sha256(`${this.state.new_password} ${user_id}`);
      let passwordObj = {
        id: user_id,
        password: pw_hash,
      };
      fetch(process.env.REACT_APP_BASEURL + 'getLastPasswords/', {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(passwordObj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((passwordmatch) => {
          let is_password_match = JSON.parse(passwordmatch);
          let sha256 = require('js-sha256');
          let current_password_hash = sha256(`${this.state.current_password}`);
          let new_password_hash = sha256(`${this.state.new_password}`);
          if (
            is_password_match.res === true ||
            is_password_match.res === 'true'
          ) {
            this.setState({ errorMessage: 'Password already exists.' });
          } else if (current_password_hash === new_password_hash) {
            this.setState({ errorMessage: 'Password already exists.' });
          } else {
            Auth.signIn(
              JSON.parse(sessionStorage.getItem('user')).username,
              this.state.current_password
            )
              .then((updatedUser) => {
                Auth.changePassword(
                  updatedUser,
                  this.state.current_password,
                  this.state.new_password
                )
                  .then((result) => {
                    if (result === 'SUCCESS') {
                      this.setState({
                        errorMessage: '',
                        current_password: '',
                        new_password: '',
                        confirm_new_password: '',
                        showChangePasswordDialog: false,
                      });
                    }
                    const pw_obj = {
                      userid: JSON.parse(sessionStorage.getItem('user'))
                        .username,
                      password: pw_hash,
                    };
                    fetch(process.env.REACT_APP_BASEURL + 'savepassword', {
                      method: 'post',
                      withCredentials: true,
                      headers: {
                        'Content-Type': 'application/json',
                        Authorization:
                          'Bearer ' +
                          JSON.parse(sessionStorage.getItem('user'))
                            .signInUserSession.idToken.jwtToken,
                      },
                      body: JSON.stringify(pw_obj),
                    })
                      .then((response) => {
                        try {
                          return response.text();
                        } catch (error) {
                          return null;
                        }
                      })
                      .then((uData) => { });
                    delete pw_obj.password;
                    fetch(process.env.REACT_APP_BASEURL + 'UpdateResetPWDate', {
                      method: 'post',
                      withCredentials: true,
                      headers: {
                        'Content-Type': 'application/json',
                        Authorization:
                          'Bearer ' +
                          JSON.parse(sessionStorage.getItem('user'))
                            .signInUserSession.idToken.jwtToken,
                      },
                      body: JSON.stringify(pw_obj),
                    })
                      .then((response) => {
                        try {
                          return response.text();
                        } catch (error) {
                          return null;
                        }
                      })
                      .then((uData) => { });
                  })
                  .catch((reason) => {
                    this.setState({ errorMessage: reason.message });
                  });
              })
              .catch((reason) => {
                this.setState({ errorMessage: reason.message });
              });
          }
        });
    } else {
      this.setState({ confirm_new_password_error: 'Passwords do not match.' });
    }
  };

  handleFieldChange = (event) => {
    const user = {};
    user[event.target.id] = event.target.value;

    this.setState(user);
    event.preventDefault();
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  handleSwitchChange = (isChecked) => {
    let usersData = this.state && this.state.userData && this.state.userData[0];
    var consultObject = {
      is_user_consult: isChecked,
      user_id: usersData.id,
      account_id: usersData.parent_account_id,
    };

    fetch(process.env.REACT_APP_BASEURL + 'userconsultupdate', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(consultObject),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then(async (uData) => {
        const userConsultData = JSON.parse(uData);
        this.setState({
          checkedB: userConsultData.user_consult.is_user_consult,
        });
        if (userConsultData.user_consult.is_user_consult) {
          !this.socket &&
            (await this.initSocket().then(() =>
              console.log('UserConsultFlagUpdate calling: InitSocket!')
            ));

          !this.firebaseToken &&
            (await this.initFirebaseFCM().then(() =>
              console.log('UserConsultFlagUpdate calling: InitFirebaseFCM!')
            ));
        } else {
          console.log('UserConsultFlagUpdate calling: FirebaseFCM Disconnect!');
          await this.removeFirebaseFCM();
          console.log('UserConsultFlagUpdate calling: Socket Disconnect!');
          this.socket && this.socket.disconnect();
          this.socket = false;
          this.firebaseToken = false;
        }
      });
  };
  handleReleaseOrder = () => {
    this.setState({ ReleaseOrderOpen: true });
  };
  releaseorderaccept = () => {
    this.setState({ ReleaseOrder: true });
    var statusObj = {
      user_consult_notification_id: this.state.Notifications
        .user_consult_notification_id,
      is_releaseorder: true,
    };
    fetch(process.env.REACT_APP_BASEURL + 'updateReleaseOrderStatus', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(statusObj),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.socket &&
          this.socket.emit('releaseOrder', {
            pucode: this.state.Pickupcode,
            message: 'Order Released Successfully!!',
          });
        toast.success(this.props.t('Toast.Success.OrderReleased'));
        this.state.orderNotReleasedOpen
          ? this.endConsultationSession()
          : this.setState({ ReleaseOrderOpen: false });
      });
  };
  handleCloseRleaseOrder = () => {
    this.setState({ ReleaseOrderOpen: false });
  };
  getPrescriptionDetailByPickupCode = (pickupcode) => {
    fetch(
      process.env.REACT_APP_BASEURL +
      'getprescriptiondetailbypucode/' +
      this.state.Pickupcode || pickupcode,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((pData) => {
        if (pData) {
          let data = JSON.parse(pData);
          this.setState({
            PatietPrescriptionData: data,
            PatientEmail: data[0].email,
            PatientPhone: data[0].phone,
            PatientDOB: data[0].dob,
          });
        }
      });
  };
  createRow = () => {
    const { classes } = this.props;
    let Data = this.state && this.state.PatietPrescriptionData;
    if (Data) {
      return Data.map((val, idx) => {
        return (
          <TableRow>
            <TableCell
              className={classNames(classes.removePadding)}
              style={{ padding: 0 }}
            >
              {val.rx_no}
            </TableCell>
            <TableCell
              className={classNames(classes.removePadding)}
              style={{ padding: 0 }}
            >
              {val.drug_name}
            </TableCell>
            <TableCell
              className={classNames(classes.AmountAlignment)}
              style={{ padding: 0 }}
            >
              {val.doseage_form}
            </TableCell>
            <TableCell
              className={classNames(classes.AmountAlignment)}
              style={{ padding: 0 }}
            >
              {val.qty}
            </TableCell>
          </TableRow>
        );
      });
    }
  };
  handleChangeConsultNotes = (event) => {
    event.preventDefault && event.preventDefault();
    this.setState({ consultnotes: event.target.value });
  };
  handleScheduleclick = (id) => {
    let Obj = {
      id: id,
    };
    fetch(process.env.REACT_APP_BASEURL + 'UpdateScheduleNotification', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(Obj),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        //console.log(uData);
      });
    navigate(`/home/reports/consultation/scheduleconsultreport`);
  };

  handleChangeCreateSecureBadgePassword = (e) => {
    this.setState({ createSecureBadgePassword: e.target.value });
  };

  handleOpenCreateSecureBadge = () => {
    this.setState({
      createSecureBadgeDialog: true,
      createSecureBadgePassword: '',
    });
  };

  handleSubmitCreateSecureBadge = () => {
    /**
     * calling AWS signIn api for just checking the password is correct or not.
     */
    Auth.signIn(
      JSON.parse(sessionStorage.getItem('user')).username,
      this.state.createSecureBadgePassword
    )
      .then((result) => {
        fetch(process.env.REACT_APP_BASEURL + 'generate/secure/badge', {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            Authorization: JSON.parse(sessionStorage.getItem('user'))
              .signInUserSession.idToken.jwtToken,
          },
          body: JSON.stringify({
            verifiedPassForSecureBadge: crypter.encrypt(
              this.state.createSecureBadgePassword
            ),
          }),
        })
          .then((response) => response.text())
          .then((res) => {
            res = JSON.parse(res);
            this.setState({
              loader: false,
              createSecureBadgeDialog: false,
              errorMessage: '',
            });
            res.success ? toast.success(res.message) : toast.error(res.message);
          })
          .catch((reason) => {
            toast.error(reason.message);
            this.setState({
              loader: false,
              createSecureBadgeDialog: false,
              errorMessage: reason.message,
            });
          });
      })
      .catch((reason) => {
        this.setState({
          loader: false,
          errorMessage: reason.message.includes(
            'Incorrect username or password.'
          )
            ? reason.message
            : 'Something went wrong!',
        });
      });
  };

  handleClosePopUp = (close) => {
    this.setState({ isOpen: false });
    if (!this.state.checked) {
      return true;
    }

    fetch(
      process.env.REACT_APP_BASEURL + 'releasing/history/popUpNotification',
      {
        method: 'POST',
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ispopupvisible: !this.state.checked }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState({ isOpen: false });
        return response;
      })
      .catch((error) => {
        return error;
      });
  };

  handleReload = () => {
    window.location.reload();
    this.setState({ isOpen: false });
  };

  handleCheckbox = (value) => {
    this.setState({ checked: value });
  };

  handleConsultDiagnostics = (value) =>
    this.setState({ openConsultDiagnostics: value, loader: value });

  handleAutomationMenu = (event) => {
    this.setState({ anchorAutomationEl: event.currentTarget });
  };

  gettingTaskNotification = (val) => {
    try {
      fetch(
        process.env.REACT_APP_BASEURL +
        `taskmanager/notification?isReadable=${val}`,
        {
          method: 'GET',
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          if (response) {
            let { notificationCount, notification, replica } = response['data'];
            this.setState({ notificationCount, replica });
            if (val === false) {
              this.setState({ notificationData: notification });
            } else {
              let { notificationData } = this.state;
              if (
                typeof notificationData === 'object' &&
                Object.keys(notificationData)['length'] !== 0
              ) {
                let preparedNotificationData = Object.entries(
                  notificationData
                ).reduce((obj, [node, block]) => {
                  let blockDef = notification[node] ? notification[node] : [];
                  return {
                    ...obj,
                    [node]: [...blockDef, ...block],
                  };
                }, {});
                this.setState({ notificationData: preparedNotificationData });
              } else this.setState({ notificationData: notification });
            }
          }
        });
    } catch (Error) {
      console.log(
        'Error ocurred while getting the task notification.',
        JSON.stringify({
          message: Error.message,
          stack: Error.stack,
        })
      );
    }
  };

  updateTaskNotification = (request) => {
    try {
      fetch(process.env.REACT_APP_BASEURL + 'taskmanager/updatenotification', {
        method: 'PUT',
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          TaskIDs: request,
        }),
      })
        .then((response) => response.json())
        .then(() => { });
    } catch (Error) {
      console.log(
        'Error ocurred while updating the task notification.',
        JSON.stringify({
          message: Error.message,
          stack: Error.stack,
        })
      );
    }
  };

  handleNavigateToUserProfile = () => {
    navigate(`/home/manage/users`, {
      state: { UserID: this.user.id },
      replace: false,
    });
  };

  handleClickCopyToClipboard = (val) => {
    navigator.clipboard.writeText(val)
  }

  handleMouseDownCopyToClipboard = (e) => {
    e.preventDefault();
  }

  handleSkipEvent = () => {
    this.setState({ refreshServiceWorker: false, showTroubleTitle: true });
  }

  handleShowWarning = () => {
    this.setState({ showWarning: true })
  }

  render() {
    // Getting FCM Notification from Service Worker!
    if (sw && this.state.checkedB) {
      sw.onmessage = ({ data }) => {
        if (
          data &&
          data.type &&
          ['notificationArrived', 'notificationclick'].includes(data.type)
        ) {
          this.setState(
            {
              isFirebaseNotification: true,
              firebaseNotification: {
                title: data.notification.title,
                body: data.notification.body,
              },
              Pickupcode: data.notification.body,
            },
            () => {
              console.log(
                '***FCM Notification Received At App by : ServiceWorker***'
              );
            }
          );
          console.log(
            '***ConsultCallback Function Call From : FCM Background***'
          );
          !!!this.state.consultOpen &&
            !!!this.state.startConsult &&
            this.consultCallback();
          console.log('Pickupcode: ' + this.state.Pickupcode);
        }
      };
    }

    const { classes, theme, children, t } = this.props;
    const {
      anchorEl,
      value,
      anchorElNotification,
      isOpen,
      checkedB,
      notificationData,
      notificationCount,
      userData,
      showTroubleTitle
    } = this.state;
    const currentLang = localStorage.getItem('i18nextLng');
    const open = Boolean(anchorEl);
    const openNotification = Boolean(anchorElNotification); //Added by Naresh | DI-461 | Date:16-04-2019
    const lang = localStorage.getItem('i18nextLng') || 'en';
    const _isRetail = localStorage.getItem('isRetail');
    // link to add 3rd party to on going video consultant
    const link = `https://join.localbox.net/Consultant/${this.state.Pickupcode}?sessionId=${this.state.sessionID}`

    return (
      <div className={classes.root}>
        {this.state.notificationDetails &&
          ((userData && userData[0] && userData[0].ispopupvisible) ||
            (userData && userData.ispopupvisible)) && (
            <UserPopUpNotification
              notificationDetails={this.state.notificationDetails}
              isOpen={isOpen}
              closePopup={this.handleClosePopUp}
              reload={this.handleReload}
              handelOnChangeCheckBox={this.handleCheckbox}
            />
          )}
        <ConnectIdleTimerComponent
          isConsultation={checkedB}
          signOut={this.signOut}
        />
        <ActivityIdleTimerComponent isConsultation={checkedB} />
        <Dialog
          open={this.state.refreshServiceWorker}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogContent>
            <DialogContentText className={classes.DialogText}>
              {t('Home.ServiceWorkerPopup.PerformanceOptMessage')}
              <br />
              {t('Home.ServiceWorkerPopup.LetsRefreshPageMessage')}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.ButtonAlign}>
            <Button
              onClick={this.handleSkipEvent}
              className={classes.buttonFace}
            >
              {t('Home.ServiceWorkerPopup.SKIP')}
            </Button>
            <Button
              onClick={() =>
                this.setState({ refreshServiceWorker: false }, () => {
                  window.location.reload();
                })
              }
              className={classes.buttonFace}
            >
              {t('Home.ServiceWorkerPopup.Refresh')}
            </Button>
          </DialogActions>
        </Dialog>
        {checkedB ? (
          <Dialog
            open={this.state.refreshDialog}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogContent>
              <DialogContentText className={classes.DialogText}>
                {t('Home.RefreshPopup.RefreshGetToWorkMessage')}
              </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.ButtonAlign}>
              <Button
                onClick={this.handleResetRefreshDialog}
                className={classes.buttonFace}
              >
                {t('Home.RefreshPopup.NotNow')}
              </Button>
              <Button
                onClick={() => window.location.reload()}
                className={classes.buttonFace}
              >
                {t('Home.RefreshPopup.Ok')}
              </Button>
            </DialogActions>
          </Dialog>
        ) : (
          <div>
            <IdleTimer
              ref={(ref) => {
                this.idleTimer = ref;
              }}
              element={document}
              onActive={this.onActive}
              onIdle={this.onIdle}
              onAction={this.onAction}
              debounce={parseInt(process.env.REACT_APP_IDEAL_DEBOUNCE, 10)}
              timeout={parseInt(process.env.REACT_APP_IDEAL_TIMEOUT, 10)}
            />
            <Dialog
              open={this.state.openWarning}
              onClose={this.handleCloseTimerPopUp}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
            >
              <DialogContent>
                <DialogContentText className={classes.DialogText}>
                  {t('Home.OpenWarningPopup.AreYouStillMessage')} (
                  {this.state.time}) ?
                </DialogContentText>
              </DialogContent>
              <DialogActions className={classes.ButtonAlign}>
                <Button
                  onClick={this.handleCloseTimerPopUp}
                  className={classes.buttonFace}
                >
                  {t('Home.OpenWarningPopup.Yes')}
                </Button>
              </DialogActions>
            </Dialog>
            {this.state.consultpermission && (
              <Dialog
                open={this.state.consultAcknowledgeDialog}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
              >
                <DialogContent>
                  <DialogContentText className={classes.DialogText}>
                    {t('Home.ConsultPopup.DoYouWantEnableConsult')}
                  </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.ButtonAlign}>
                  <Button
                    onClick={() =>
                      this.setState({ consultAcknowledgeDialog: false }, () => {
                        localStorage.setItem('consultAcknowledgeShowed', true);
                      })
                    }
                    className={classes.buttonFace}
                  >
                    {t('Home.ConsultPopup.NotNow')}
                  </Button>
                  <Button
                    onClick={this.handleConsultAcknowledgeDialog}
                    className={classes.buttonFace}
                  >
                    {t('Home.ConsultPopup.Yes')}
                  </Button>
                </DialogActions>
              </Dialog>
            )}
          </div>
        )}

        <Dialog
          open={this.state.showChangePasswordDialog || false}
          onClose={this.handleClose}
          aria-labelledby='form-dialog-title'
        >
          <DialogTitle id='form-dialog-title'>
            {t('Home.ChangePassPopup.ChangePasswordTitle')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t('Home.ChangePassPopup.ValidationMessage')}
              <br />
              <span>{t('Home.ChangePassPopup.PassCannotBeOneOfLast')}</span>
              <br />
              <span className={classes.errorText}>
                {this.state.errorMessage}
              </span>
            </DialogContentText>
            <TextField
              autoFocus
              className={classes.halfTextField}
              margin='normal'
              id='current_password'
              label={t('Home.ChangePassPopup.CurrentPassword')}
              placeholder=''
              type='password'
              onBlur={this.handleFieldChange}
              fullWidth
              InputProps={{
                autocomplete: 'new-password',
                form: {
                  autocomplete: 'off',
                },
              }}
              variant='standard'
            />
            <TextField
              className={classes.halfTextField}
              margin='normal'
              id='new_password'
              label={t('Home.ChangePassPopup.NewPassword')}
              type='password'
              onChange={this.handleFieldChange}
              fullWidth
              InputProps={{
                autocomplete: 'new-password',
                form: {
                  autocomplete: 'off',
                },
              }}
              variant='standard'
            />

            <TextField
              className={classes.halfTextField}
              margin='normal'
              id='confirm_new_password'
              label={t('Home.ChangePassPopup.ConfirmPassword')}
              type='password'
              error={
                this.state.confirm_new_password_error &&
                this.state.confirm_new_password_error.length > 0
              }
              helperText={this.state.confirm_new_password_error}
              onChange={this.handleFieldChange}
              fullWidth
              InputProps={{
                autocomplete: 'new-password',
                form: {
                  autocomplete: 'off',
                },
              }}
              variant='standard'
            />

            <br />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleClose}
              className={classes.primaryButton}
            >
              {t('Home.ChangePassPopup.Cancel')}
            </Button>
            <Button
              onClick={this.handleSubmit}
              className={classes.primaryButton}
            >
              {t('Home.ChangePassPopup.ChangePassword')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.createSecureBadgeDialog || false}
          onClose={this.handleClose}
          aria-labelledby='form-dialog-title'
        >
          <DialogTitle id='form-dialog-title'>
            {t('Home.SecureBadgePopup.SecureBadgeTitle')}
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              className={classes.halfTextField}
              margin='normal'
              id='createSecureBadgePassword'
              label={t('Home.SecureBadgePopup.EnterPassword')}
              placeholder=''
              type='password'
              onChange={this.handleChangeCreateSecureBadgePassword}
              error={
                this.state.errorMessage && this.state.errorMessage.length > 0
              }
              helperText={this.state.errorMessage}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton disabled>
                      <Lock />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant='standard'
              sx={{ width: '30ch' }}
            />
            <br />
          </DialogContent>
          {this.state.loader && (
            <div className={classes.loader}>
              <img
                className={classes.loaderImage}
                src={defaultLoader}
                alt='Processing'
                style={{ width: '80%' }}
              />
            </div>
          )}
          <DialogActions>
            <Button
              onClick={this.handleClose}
              className={classes.primaryButton}
            >
              {t('Home.SecureBadgePopup.Cancel')}
            </Button>
            <Button
              disabled={this.state.createSecureBadgePassword === ''}
              onClick={(e) => {
                this.setState({ loader: true, errorMessage: '' });
                this.handleSubmitCreateSecureBadge();
              }}
              className={classes.primaryButton}
            >
              {t('Home.SecureBadgePopup.CreateSecureBadge')}
            </Button>
          </DialogActions>
        </Dialog>

        <AppBar
          id='react-no-print'
          position='absolute'
          className={classNames(
            classes.appBar,
            this.state.open && classes.appBarShift
          )}
        >
          <Toolbar disableGutters>
            <IconButton
              aria-label='open drawer'
              onClick={
                !this.state.open
                  ? this.handleDrawerOpen
                  : this.handleDrawerClose
              }
              className={classNames(classes.menuButton)}
            >
              <MenuIcon />
            </IconButton>
            <Box component='div' className={classes.flex}>
              <Typography variant='title' noWrap style={{ color: 'white' }}>
                {t('Navbar.RxConnect')}
              </Typography>
              {[false, 'false'].includes(_isRetail) &&
              <Typography
                variant='title'
                noWrap
                sx={{
                  ml: '6.5rem',
                  color: 'white',
                  cursor: 'pointer',
                  fontWeight: 400,
                  fontSize: '1rem',
                  lineHeight: 1.5,
                  letterSpacing: '0.00938em',
                }}
                onClick={this.handleAutomationMenu}
              >
                {t('Navbar.Automation')}
              </Typography>}
              {(currentLang === 'en' && [false, 'false'].includes(_isRetail)) && (
                <Typography
                  variant='title'
                  noWrap
                  sx={{
                    ml: '1.5rem',
                    color: 'white',
                    cursor: 'pointer',
                    fontWeight: 400,
                    fontSize: '1rem',
                    lineHeight: 1.5,
                    letterSpacing: '0.00938em',
                  }}
                >
                  <Link
                    to='/home/taskmanager'
                    style={{
                      textDecoration: 'none',
                      color: 'white',
                    }}
                  >
                    {t('Navbar.Task')}
                  </Link>
                </Typography>
              )}
              <Menu
                anchorEl={this.state.anchorAutomationEl}
                id='AutomationMenu'
                keepMounted
                open={Boolean(this.state.anchorAutomationEl)}
                onClose={() => this.setState({ anchorAutomationEl: null })}
                onClick={() => this.setState({ anchorAutomationEl: null })}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 4.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <Link
                  to='/home/automation'
                  style={{
                    textDecoration: 'none',
                    color: '#232323',
                  }}
                >
                  <MenuItem>
                    <ListItemIcon>
                      <AttachEmail fontSize='small' />
                    </ListItemIcon>
                    {t('Navbar.Email')}
                  </MenuItem>
                </Link>
              </Menu>
            </Box>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {/* Added By : Belani Jaimin */}
              {showTroubleTitle ? (
                <div
                  onClick={this.handleShowWarning}
                  style={{
                    marginRight: '10px',
                    background: 'red',
                    border: '1px solid red',
                    padding: '5px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}>
                  {t("Home.ServiceWorkerPopup.ErrorMessage_1")}
                </div>
              ) : null}
              {this.state && this.state.consultpermission === true ? (
                <React.Fragment>
                  <FormControlLabel
                    label={t('Navbar.Consult')}
                    sx={{ mr: 0 }}
                    control={
                      <Switch
                        classes={{
                          switchBase: classes.iOSSwitchBase,
                          bar: classes.iOSBar,
                          icon: classes.iOSIcon,
                          iconChecked: classes.iOSIconChecked,
                          checked: classes.iOSChecked,
                        }}
                        checked={this.state.checkedB}
                        onChange={(e) =>
                          this.handleSwitchChange(e.target.checked)
                        }
                      />
                    }
                  />
                  {currentLang === 'en' && (
                    <Typography
                      sx={{ m: '0 15px 0 15px', cursor: 'pointer' }}
                      onClick={() => this.handleConsultDiagnostics(true)}
                    >
                      {t('Navbar.TestConsult')}
                    </Typography>
                  )}
                </React.Fragment>
              ) : (
                ''
              )}
              {/* Modified by Naresh | DI-461 | Date:16-04-2019  */}
              <IconButton
                aria-owns={openNotification ? 'menu-appbar' : null}
                aria-haspopup='true'
                onClick={this.handleOpenNotificationMenu}
                sx={{ mr: '10px' }}
              >
                <Badge
                  badgeContent={notificationCount}
                  color='success'
                  max={20}
                >
                  <BellIcon sx={{ color: 'white' }} />
                </Badge>
              </IconButton>
              {typeof notificationData === 'object' &&
                notificationData !== null && (
                  <NotificationWrapperComponent
                    anchorEl={anchorElNotification}
                    openMenu={openNotification}
                    closeMenu={this.handleCloseNotificationMenu}
                    notificationData={notificationData}
                  />
                )}
              {/* End Naresh | DI-461 */}
              <IconButton
                aria-owns={open ? 'menu-appbar' : null}
                aria-haspopup='true'
                onClick={this.handleMenu}
              >
                {/* <AccountCircle /> */}
                {/* { !this.state.userData && <Avatar alt="UserAvatar" src={avatarProfile} className={classes.avatar} />} */}
                {this.state.userData && (
                  <Avatar
                    alt='UserAvatar'
                    src={
                      this.state.userData &&
                        this.state.userData.length &&
                        this.state.userData.length > 0 &&
                        this.state.userData[0] &&
                        this.state.userData[0].picture_url
                        ? this.state.userData[0].picture_url
                        : this.state.ilocalboxAvatarprofile
                    }
                    className={classes.avatar}
                  />
                )}
              </IconButton>
              <Typography
                variant='subheading'
                className={classes.userName}
                onClick={this.handleMenu}
                sx={{ pr: '6px' }}
              >
                {JSON.parse(sessionStorage.getItem('user')) &&
                  JSON.parse(sessionStorage.getItem('user')).signInUserSession ? (
                  <span>
                    <span>
                      {
                        JSON.parse(sessionStorage.getItem('user'))
                          .signInUserSession.idToken.payload.name
                      }
                    </span>
                    <p style={{ marginTop: '-32px' }}>
                      {sessionStorage.getItem('parentAccountName')}
                    </p>
                  </span>
                ) : (
                  setTimeout(
                    () => this.props.navigate('/', { replace: true }),
                    0
                  )
                )}
              </Typography>
              <Menu
                id='menu-appbar'
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                open={Boolean(open)}
                onClose={this.handleClose_menu}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 7.3,
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}
              >
                <MenuItem onClick={this.handleChangePasswored}>
                  {t('Navbar.ChangePassword')}
                </MenuItem>
                <MenuItem onClick={this.handleOpenCreateSecureBadge}>
                  {t('Navbar.SecureBadge')}
                </MenuItem>
                <MenuItem>
                  <Link
                    tag='a'
                    to='/home/manage/users/1'
                    style={{ textDecoration: 'none', color: 'black' }}
                  >
                    {t('Navbar.Preferences')}
                  </Link>
                </MenuItem>
                <MenuItem onClick={this.signOut}>
                  {t('Navbar.SignOut')}
                </MenuItem>
              </Menu>
            </div>
            <IconButton
              className={classes.signOutButton}
              onClick={this.signOut}
            >
              <SignOutIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div id='react-no-print'>
          <Drawer
            variant='permanent'
            classes={{
              paper: classNames(
                classes.drawerPaper,
                !this.state.open && classes.drawerPaperClose
              ),
            }}
            open={this.state.open}
          >
            <div id='react-no-print' className={classes.toolbar}>
              <IconButton onClick={this.handleDrawerClose}>
                {theme.direction === 'rtl' ? (
                  <ChevronRightIcon />
                ) : (
                  <ChevronLeftIcon />
                )}
              </IconButton>
            </div>
            <Divider />
            <List style={{ paddingBottom: '0px' }}>{mailFolderListItems}</List>
            <List style={{ paddingTop: '10px', paddingBottom: '0px' }}>
              <ReportLink isVisible={this.state.isUnplugged} />
            </List>
            <Divider />
            <List style={{ paddingTop: '0px' }}>
              {otherMailFolderListItems}
            </List>
            <List style={{ paddingTop: '0px' }}>
              <ManagemenuLink />
            </List>
          </Drawer>
        </div>
        <main
          className={
            !this.state.open ? classes.contentWithMiniLeftNav : classes.content
          }
        >
          <div className={classes.toolbar} />

          {children}

          <BottomNavigation
            id='react-no-print'
            value={value}
            onChange={this.handleBottomNavChange}
            showLabels
            className={classes.bottomNav}
          >
            <BottomNavigationAction
              label='Dashboard'
              icon={<DashboardIcon />}
            />
            <BottomNavigationAction
              label='Assign'
              icon={<AssignPrescriptionIcon />}
            />
            <BottomNavigationAction
              label='Review'
              icon={<ReviewPrescriptionIcon />}
            />
            <BottomNavigationAction
              label='Stock'
              icon={<StockPrescriptionIcon />}
            />
          </BottomNavigation>
        </main>

        {/*
          Added : By Belani jaimin
          Added Date : 01/16/2019
          Description : Open dialog for consult
        */}
        {!!!this.state.startConsult && (
          <Dialog
            open={this.state.consultOpen}
            onClose={this.handleConsultClose}
            classes={{ paper: classes.consultDialogBox }}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <div>
              <DialogTitle
                className={classes.consultDialogTitle}
                id='alert-dialog-title'
              >
                {t('Home.StartConsultPopup.CallingFrom')}{' '}
                <span className={classes.consultLocationName}>
                  {this.state.Notifications.store_name}
                </span>
              </DialogTitle>
              <DialogContent>
                <div className={classes.consultDialogDataContainer}>
                  {this.state.Notifications &&
                    this.state.Notifications.picture_url &&
                    this.state.Notifications.picture_url !== '' &&
                    this.state.Notifications.picture_url !== null &&
                    this.state.Notifications.picture_url !== 'null' &&
                    this.state.Notifications.picture_url !== undefined &&
                    this.state.Notifications.picture_url !== 'undefined' ? (
                    <img
                      src={this.state.Notifications.picture_url}
                      alt={this.state.PatientName}
                      className={classes.consultDialogPatientImage}
                    />
                  ) : (
                    <img
                      src={this.state && this.state.ilocalboxAvatarprofile}
                      alt='ilocalboxAvatarlogo'
                      className={classes.consultDialogPatientImage}
                    />
                  )}
                  <DialogContentText className={classes.consultDialogText}>
                    {this.state.PatientName}{' '}
                    {t('Home.StartConsultPopup.RequestConsultPatientName')}
                  </DialogContentText>
                  {this.state.loader ? (
                    <div className={classes.loader}>
                      <img
                        className={classes.loaderImage}
                        src={wait}
                        alt='Processing'
                      />
                    </div>
                  ) : null}
                </div>
              </DialogContent>
              <DialogActions className={classes.consultDialogButtons}>
                <Button onClick={this.declineConsultCall}>
                  <h2>{t('Home.StartConsultPopup.Decline')}</h2>
                </Button>
                <Button
                  disabled={this.state.isButtonDisabled}
                  onClick={this.acceptConsultCall}
                >
                  <h2>{t('Home.StartConsultPopup.Accept')}</h2>
                </Button>
              </DialogActions>
            </div>
          </Dialog>
        )}

        <Dialog
          open={this.state.startConsult}
          onClose={this.handleConsultClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
          PaperProps={{
            style: { borderRadius: '5px', maxWidth: '100%', width: '70%' },
          }}
        >
          <div style={{ background: 'transperent' }}>
            <div>
              <div
                style={{
                  height: '70px',
                  textAlign: 'left',
                  padding: '20px',
                  fontSize: '1.5em',
                  fontWeight: 500,
                  backgroundColor: '#00a7e1 !important',
                  boxShadow:
                    '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
                  color: '#fff !important',
                }}
              >
                <div id='alert-dialog-title'>
                  <Typography variant='title' noWrap className={classes.flex}>
                    {t('Home.StartConsultPopup.ConsultRoom')}{' '}
                    {this.state.Pickupcode}
                  </Typography>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ width: '100%' }}>
                  <DialogContent>
                    <DialogContentText
                      className={classes.DialogText}
                    >
                      <div
                        id='renderer'
                        style={{ height: 'auto', maxWidth: '48%' }}
                      >
                        <Zoom
                          identity={this.state.PatientName}
                          roomName={this.state.Pickupcode}
                          onRef={(ref) => (this.zoom = ref)}
                        />
                      </div>
                    </DialogContentText>
                    {JSON.parse(localStorage.getItem('is3rdPartyConsultation')) ? <OutlinedInput
                      sx={{ height: "25px", width: "40ch", padding: "0", marginLeft: "4px", }}
                      id="outlined-adornment-copyToClipboard"
                      value={link}
                      readOnly
                      type="text"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="copy to clipboard"
                            onClick={() => this.handleClickCopyToClipboard(link)}
                            onMouseDown={this.handleMouseDownCopyToClipboard}
                            edge="end"
                          >
                            <ContentCopyIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                    /> : null}
                  </DialogContent>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <div style={{ width: '50%' }}>
                    <DialogContent>
                      <Accordion defaultExpanded={true}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls='panel1a-content'
                          id='panel1a-header'
                          style={{
                            backgroundColor: 'rgba(0, 0, 0, .03)',
                            borderBottom: '1px solid rgba(0, 0, 0, .125)',
                            marginBottom: -1,
                            minHeight: 56,
                          }}
                        >
                          <Typography className={classes.heading}>
                            <b>{t('Home.StartConsultPopup.PatientDetails')}</b>
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ height: '100px' }}>
                          <Table className={classes.table}>
                            <TableBody>
                              <TableRow style={{ height: 20 }}>
                                <TableCell
                                  className={classNames(classes.removePadding)}
                                  style={{ padding: 0, borderBottom: 'none' }}
                                >
                                  <b>{t('Home.StartConsultPopup.Name')}</b>
                                </TableCell>
                                <TableCell
                                  className={classNames(classes.removePadding)}
                                  style={{ padding: 0, borderBottom: 'none' }}
                                >
                                  :
                                </TableCell>
                                <TableCell
                                  className={classNames(classes.removePadding)}
                                  style={{ padding: 0, borderBottom: 'none' }}
                                >
                                  {this.state.PatientName}
                                </TableCell>
                              </TableRow>
                              <TableRow style={{ height: 20 }}>
                                <TableCell
                                  className={classNames(classes.removePadding)}
                                  style={{ padding: 0, borderBottom: 'none' }}
                                >
                                  <b>{t('Home.StartConsultPopup.Email')}</b>
                                </TableCell>
                                <TableCell
                                  className={classNames(classes.removePadding)}
                                  style={{ padding: 0, borderBottom: 'none' }}
                                >
                                  :
                                </TableCell>
                                <TableCell
                                  className={classNames(classes.removePadding)}
                                  style={{ padding: 0, borderBottom: 'none' }}
                                >
                                  {this.state.PatientEmail}
                                </TableCell>
                              </TableRow>
                              <TableRow style={{ height: 20 }}>
                                <TableCell
                                  className={classNames(classes.removePadding)}
                                  style={{ padding: 0, borderBottom: 'none' }}
                                >
                                  <b>{t('Home.StartConsultPopup.Contact')}</b>
                                </TableCell>
                                <TableCell
                                  className={classNames(classes.removePadding)}
                                  style={{ padding: 0, borderBottom: 'none' }}
                                >
                                  :
                                </TableCell>
                                <TableCell
                                  className={classNames(classes.removePadding)}
                                  style={{ padding: 0, borderBottom: 'none' }}
                                >
                                  {this.state.PatientPhone}
                                </TableCell>
                              </TableRow>
                              <TableRow style={{ height: 20 }}>
                                <TableCell
                                  className={classNames(classes.removePadding)}
                                  style={{ padding: 0, borderBottom: 'none' }}
                                >
                                  <b>{t('Home.StartConsultPopup.DateOfBirth')}</b>
                                </TableCell>
                                <TableCell
                                  className={classNames(classes.removePadding)}
                                  style={{ padding: 0, borderBottom: 'none' }}
                                >
                                  :
                                </TableCell>
                                <TableCell
                                  className={classNames(classes.removePadding)}
                                  style={{ padding: 0, borderBottom: 'none' }}
                                >
                                  {this.state.PatientDOB}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </AccordionDetails>
                      </Accordion>
                    </DialogContent>
                    <DialogContent style={{ height: '60%' }}>
                      <Table className={classes.table}>
                        <TableHead className={classNames(classes.TableHead)}>
                          <TableRow>
                            <TableCell
                              className={classNames(classes.NameCellWidth)}
                              style={{ padding: 0 }}
                            >
                              <b>{t('Home.StartConsultPopup.RxHash')}</b>
                            </TableCell>
                            <TableCell
                              className={classNames(classes.NameCellWidth)}
                              style={{ padding: 0 }}
                            >
                              <b>{t('Home.StartConsultPopup.DrugName')}</b>
                            </TableCell>
                            <TableCell
                              className={classNames(classes.AmountCell)}
                              style={{ padding: 0 }}
                            >
                              <b>{t('Home.StartConsultPopup.Dose')}</b>
                            </TableCell>
                            <TableCell
                              className={classNames(classes.AmountCell)}
                              style={{ padding: 0 }}
                            >
                              <b>{t('Home.StartConsultPopup.Qty')}</b>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>{this.createRow()}</TableBody>
                      </Table>
                    </DialogContent>
                    {!!!this.state.isNormalConsult && (
                      <DialogContent>
                        <div>
                          <FormControlLabel
                            label={t('Home.StartConsultPopup.ReleaseOrder')}
                            control={
                              <Checkbox
                                disabled={this.state.ReleaseOrder}
                                checked={this.state.ReleaseOrder}
                                onChange={() => this.handleReleaseOrder('')}
                                value={this.state.ReleaseOrder}
                              />
                            }
                            style={{ marginLeft: '0px', marginRight: '0px' }}
                          />
                        </div>
                      </DialogContent>
                    )}
                  </div>
                  <div style={{ width: '50%' }}>
                    <div
                      style={{
                        position: 'absolute',
                        bottom: '15%',
                        right: 0,
                        width: '50%',
                      }}
                    >
                      <DialogContent>
                        <Typography
                          variant='title'
                          noWrap
                          className={classes.flex}
                        >
                          {' '}
                          {t('Home.StartConsultPopup.ConsultNotes')}
                        </Typography>
                        <TextareaAutosize
                          style={{
                            minHeight: 130,
                            maxHeight: 130,
                            width: '100%',
                            boxSizing: 'border-box',
                            border: '1px solid rgba(224, 224, 224, 1)',
                            fontSize: '0.8125rem',
                            fontWeight: '400',
                            padding: '10px',
                            fontFamily: 'Roboto,Helvetica,Arial,sans-serif',
                            color: 'rgba(0, 0, 0, 0.87)',
                          }}
                          //placeholder="Consultaion Notes"
                          onBlur={this.handleChangeConsultNotes}
                          onChange={this.handleChangeConsultNotes}
                          label='Consultation Notes'
                          defaultValue={this.state.consultnotes}
                        />
                      </DialogContent>
                    </div>
                  </div>
                </div>
              </div>

              <DialogActions style={{ textAlign: 'right' }}>
                <Button
                  onClick={
                    this.state.ReleaseOrder || this.state.isNormalConsult
                      ? this.endConsultationSession
                      : () => this.setState({ orderNotReleasedOpen: true })
                  }
                  className={classes.primaryButton}
                >
                  {t('Home.StartConsultPopup.CompleteConsult')}
                </Button>
              </DialogActions>
            </div>
          </div>
        </Dialog>

        <Dialog
          open={this.state.ReleaseOrderOpen}
          onClose={this.handleCloseRleaseOrder}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogContent className={classes.DialogContentWrap}>
            <DialogContentText className={classes.DialogText}>
              {t('Home.ReleaseOrderPopup.AreYouSureMessage')}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.ButtonAlign}>
            <Button
              className={classes.buttonFace}
              onClick={this.releaseorderaccept}
            >
              {t('Home.ReleaseOrderPopup.Yes')}
            </Button>
            <Button
              disabled={this.state.isButtonDisabled}
              className={classes.buttonFace}
              onClick={this.handleCloseRleaseOrder}
            >
              {t('Home.ReleaseOrderPopup.No')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.orderNotReleasedOpen}
          onClose={this.handleConsultClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogContent className={classes.DialogContentWrap}>
            <DialogContentText className={classes.DialogText}>
              {t('Home.OrderNotReleasePopup.HaveNotReleaseMessage')}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.ButtonAlign}>
            <Button
              className={classes.primaryButton}
              onClick={this.releaseorderaccept}
            >
              {t('Home.OrderNotReleasePopup.ReleaseOrder')}
            </Button>
            <Button
              disabled={this.state.isButtonDisabled}
              className={classes.primaryButton}
              onClick={this.endConsultationSession}
            >
              {t('Home.OrderNotReleasePopup.CompleteConsult')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={
            !window.location.host.includes('.ca') &&
            this.state.openConsultDiagnostics
          }
          onClose={() => this.handleConsultDiagnostics(false)}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
          className={classes.diagnostics_dialogbox}
        >
          <DialogTitle>
            <span>{t('Home.ConsultDiagnosisPopup.ConsultDiagnosisTitle')}</span>
            <IconButton onClick={() => this.handleConsultDiagnostics(false)}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className='container'>
            <iframe
              title='Consult Diagnostics - iLocalBox'
              src={process.env.REACT_APP_CONSULT_DIAGNOSTICS_APP_URL + lang}
              frameborder='0'
              allow='camera; microphone'
              onLoad={() => this.setState({ loader: false })}
            />
          </DialogContent>
          {this.state.loader && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(255,255,255,0.3)',
                zIndex: '999999',
              }}
            >
              <img
                src={defaultLoader}
                alt='Processing'
                style={{
                  position: 'absolute',
                  top: '50%',
                  width: '100px',
                  zIndex: '999999999',
                }}
              />
            </div>
          )}
        </Dialog>

        <Dialog
          open={this.state.checkedBDialog}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogContent>
            <DialogContentText className={classes.DialogText}>
              {t('Home.CheckBPopup.LetsTestBrowserMessage')}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.ButtonAlign}>
            <Button
              onClick={() => this.setState({ checkedBDialog: false })}
              className={classes.buttonFace}
            >
              {t('Home.CheckBPopup.NotNow')}
            </Button>
            <Button
              onClick={() =>
                this.setState({ checkedBDialog: false }, () => {
                  this.handleConsultDiagnostics(true);
                  localStorage.setItem('consultDiagnosticsShowed', true);
                })
              }
              className={classes.buttonFace}
            >
              {t('Home.CheckBPopup.Yes')}
            </Button>
          </DialogActions>
        </Dialog>

        <div id='react-no-print' className={classes.footer}>
          <div style={{ float: 'left' }}>
            <span style={{ fontWeight: 500 }}>
              {' '}
              {t('Home.Footer.Copyright')}
            </span>{' '}
            &copy; 2018 - {new Date().getFullYear()}{' '}
            <a
              target='new'
              style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none' }}
              href='https://ilocalbox.com/'
            >
              {t('Home.Footer.iLocalBox')}
            </a>
            . {t('Home.Footer.AllRightReserved')}
          </div>
          <div style={{ float: 'right' }}>
            <label style={{ fontSize: '0.8rem' }}>
              <span style={{ fontWeight: 500 }}>
                {t('Home.Footer.Version')}
              </span>{' '}
              {packageJson.version}
            </label>
          </div>
        </div>
        <Dialog
          open={this.state.showWarning}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogContent>
            <DialogContentText className={classes.DialogText}>
              {t('Home.ServiceWorkerPopup.ErrorMessage_2')}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.ButtonAlign}>
            <Button
              onClick={() =>
                this.setState({ refreshServiceWorker: false }, () => {
                  window.location.reload();
                })
              }
              className={classes.buttonFace}
            >
              {t('Home.ServiceWorkerPopup.Refresh')}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(withTranslation()(Home));



// WEBPACK FOOTER //
// ./src/components/home/index.js